import { RecentlyUsedFont } from "../types/recentlyUsedFont";

export const RECENTLY_USED_FONTS_KEY = "mg-recently-used-fonts";

export function getRecentlyUsedFonts(): RecentlyUsedFont[] {
    return JSON.parse(localStorage.getItem(RECENTLY_USED_FONTS_KEY) || "[]");
}
